import {
  REQUEST_MEGAPHONE_BANNER, UPDATE_MEGAPHONE_BANNER, CREATE_MEGAPHONE_BANNER,
} from '../actionTypes';

export const currentMegaphoneBannerGet = () => ({
  type: REQUEST_MEGAPHONE_BANNER,
});

export const currentMegaphoneBannerUpdate = (id, data) => ({
  type: UPDATE_MEGAPHONE_BANNER,
  payload: { id, data },
});

export const megaphoneBannerCreate = (data) => ({
  type: CREATE_MEGAPHONE_BANNER,
  payload: data,
});
